import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ChallengesPage from './views/ChallengesPage';
import HomePage from "./views/HomePage";
import LoginPage from "./views/LoginPage";
import SchedulerPage from "./views/SchedulerPage";
import ChallengeDetailPage from "./views/ChallengeDetailPage";
import SignUpPage from "./views/SignUpPage"; // Import the new SignUpPage
import ForgotPasswordPage from "./views/ForgotPasswordPage"; // Import the new ForgotPasswordPage
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import Layout from './components/Layout';
import LessonPlansPage from './views/LessonPlansPage';
import LessonPlanDetailPage from './views/LessonPlanDetailPage';
import ProgramsPage from './views/ProgramsPage';
import EventPage from './views/EventPage';
import { VideoProvider } from './contexts/VideoContext';

// Inside <Routes>:


function App() {
    return (
        <AuthProvider>
          <PermissionProvider>
            <VideoProvider>
                <div className="app-container">
                    <div className="content-container">
                        <Router>
                            <Routes>
                                <Route element={<Layout />} >
                                    <Route path="/" element={<HomePage />} />
                                    <Route path="/login" element={<LoginPage />} />
                                    <Route path="/signup" element={<SignUpPage />} /> {/* New Signup Route */}
                                    <Route path="/forgot-password" element={<ForgotPasswordPage />} /> {/* New Forgot Password Route */}
                                    <Route path="/challenges" element={<ChallengesPage />} />
                                    <Route path="/scheduler" element={<SchedulerPage />} />
                                    <Route path="/challenges/:challengeId" element={<ChallengeDetailPage />} />
                                    <Route path="/lesson-plans" element={<LessonPlansPage />} />
                                    <Route path="/lesson-plans/:lessonPlanId" element={<LessonPlanDetailPage />} />
                                    <Route path="/programs" element={<ProgramsPage />} />
                                    <Route path="/events" element={<EventPage />} />
                                 </Route>
                            </Routes>
                        </Router>
                    </div>
                </div>
            </VideoProvider>
          </PermissionProvider>
        </AuthProvider>
    );
}

export default App;